import { BaseModel } from "sjs-base-model";

export default class A7ProductModel extends BaseModel {
    id = "";
    name = "";
    description = "";
    category = "";
    subcategory = "";
    price = 0;
    upsellingProducts = [];
    trialPeriodInWeeks = 0;
    trial = false;
    remark = "";
    visible = false;
    subProducts = []; // for sample data
    
    constructor(data) {
        super();
        this.update(data);
    }
}